import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpHelpService } from "../service/http-help.service";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import Swal from 'sweetalert2';
import { AddProductEndPoint } from "../service/global.service";
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"]
})

export class ProductsComponent implements OnInit, OnDestroy {
  @Input() isInsideModal: boolean = false;
  @ViewChild('importResultModal') importResultModal: any;
  @ViewChild('aiPreviewModal') aiPreviewModal: any;
  openedIndex: number | null = null;
  importResult: any = null;

  curentLang:string="";
  layoutVersion:any;
  userRegistId:any = JSON.parse(localStorage.getItem('user_id'));
  merchantId = JSON.parse(localStorage.getItem('merchant_id'));
  user_type = JSON.parse(localStorage.getItem('user_type'));
  term:any;
  p: any;
  addProduct:FormGroup;
  updateProduct:FormGroup;
  productsData:any=[];
  customerDataMerchant:any=[];
  customerTypeData:any=[];
  productId: number;
  updatedData: any;
  viewData: any;
  categoriesData:any=[];
  unitMesauereData:any=[];
  companiesData:any=[];
  merchantCategoriesData:any=[];
  selectedProduct:any;
  selectedMeasurementUnit:any;
  currentPage: number = 1;
  limit: number = 50;
  offset: number = 0;
  total: number = 0; 
  public validate = false;
  public validateUpdate = false;

  currentImageUrl: string | null = null;
  aiPreviewUrl: string | null = null;
  aiPreviewKey: string | null = null;
  aiPrompt: string = '';
  pendingPreviewKey: string | null = null;

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private spinner: NgxSpinnerService ,
    public translate:TranslateService ,
    private service:HttpHelpService  ,
    private modalService: NgbModal,
  ) 
  { 
    this.curentLang = localStorage.getItem('curentLang');
    this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
    this.user_type = JSON.parse(localStorage.getItem('user_type'));

    this.addProduct = new FormGroup({
      product_name_en: new FormControl('', Validators.required),
      product_name_ar: new FormControl('', Validators.required),
      product_name_he: new FormControl('', Validators.required),
      des_ar: new FormControl('', Validators.required),
      des_en: new FormControl('', Validators.required),
      des_he: new FormControl('', Validators.required),
      product_code: new FormControl(''),
      barcode: new FormControl(''),
      company_id: new FormControl(null),
      price: new FormControl(0, Validators.required),
      measurement_unit_id: new FormControl('', Validators.required),
      categories_id: new FormControl(null),
      merchant_category_id: new FormControl(null),
      show_in_pos: new FormControl(true),
      pos_sort_order: new FormControl(0),
      auto_generate_sku: new FormControl(false),
      auto_generate_barcode: new FormControl(false),
      generate_ai_image: new FormControl(false),
      ai_image_prompt: new FormControl(''),
      merchant_id: new FormControl(this.merchantId),
      created_by: new FormControl(this.userRegistId),
    });

    this.updateProduct=new FormGroup({
      product_name_en :new FormControl('' , Validators.required),
      product_name_ar:new FormControl('' , Validators.required),
      product_name_he :new FormControl('' , Validators.required),  
      des_ar :new FormControl('' , Validators.required), 
      des_en :new FormControl('' , Validators.required), 
      des_he :new FormControl('' , Validators.required), 
      product_code :new FormControl(''),
      barcode: new FormControl(''),
      company_id: new FormControl(null),
      price :new FormControl('' , Validators.required),  
      measurement_unit_id :new FormControl('' , Validators.required),  
      categories_id :new FormControl(null),
      merchant_category_id: new FormControl(null),
      show_in_pos: new FormControl(true),
      pos_sort_order: new FormControl(0),
      auto_generate_sku: new FormControl(false),
      auto_generate_barcode: new FormControl(false),
      generate_ai_image: new FormControl(false),
      ai_image_prompt: new FormControl(''),
      merchant_id :new FormControl(this.merchantId),   
      updated_by:new FormControl(this.userRegistId),
    });
  };

  private msg(ar: string, en: string, he: string): string {
    return this.curentLang === 'ar' ? ar : (this.curentLang === 'en' ? en : he);
  }

  private apiMsg(res: any): string {
    return this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
  }

  toggleCollapse(index: number): void {
    this.openedIndex = this.openedIndex === index ? null : index;
  };

  onSearchInput(): void {
    this.searchSubject.next(this.term || '');
  }

  onPageChange(page: number) {
    this.currentPage = page;
    const offset = (page - 1) * this.limit;
    this.getAllProductsBasedOnMerchant(this.limit, offset);
  }

  openXl(content:any) {
    this.resetAddForm();
    this.productId = null as any;
    this.currentImageUrl = null;
    this.modalService.open(content, { size: 'xl' , centered:true });
  };

  getAllProductsBasedOnMerchant(limit?: number, offset?: number) {
    limit = limit || this.limit;
    offset = offset ?? (this.currentPage - 1) * this.limit;
    this.spinner.show();
    this.service.getAllProductsBasedOnMerchant(limit, offset, this.term).subscribe({
      next: res => {
        this.productsData = res.products;
        this.total = res.count;
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  };

  getAllCustomerType() {
    this.spinner.show();
    this.service.getAllCustomerType().subscribe({
      next: res => {
        this.customerTypeData = res;
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  };

  getAllActiveCategories() {
    this.spinner.show();
    this.service.getAllActiveCategories().subscribe({
      next: res => {
        this.categoriesData = res;
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  };

  getAllActiveMeasurementUnits() {
    this.spinner.show();
    this.service.getAllActiveMeasurementUnits().subscribe({
      next: res => {
        this.unitMesauereData = res;
         this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  };

  getAllActiveCompanies() {
    this.service.getAllActiveCompanyByMerchant().subscribe({
      next: res => {
        this.companiesData = Array.isArray(res) ? res : (res?.data || []);
      },
      error: () => {
        this.companiesData = [];
      }
    });
  }

  getActiveMerchantCategories() {
    this.service.getActiveMerchantProductCategories().subscribe({
      next: res => {
        this.merchantCategoriesData = Array.isArray(res)
          ? res
          : (res?.data || res?.categories || []);
      },
      error: () => {
        this.merchantCategoriesData = [];
      }
    });
  }

  merchantCategoryPk(item: any): number {
    return Number(item?.merchant_category_id ?? item?.id);
  }

  merchantCategoryLabel(item: any): string {
    if (!item) return '';
    return this.curentLang === 'en'
      ? item.name_en
      : this.curentLang === 'ar'
        ? item.name_ar
        : item.name_he;
  }

  private requiresCompany(form: FormGroup): boolean {
    const code = String(form.value.product_code || '').trim();
    const barcode = String(form.value.barcode || '').trim();
    return !!(code || barcode || form.value.auto_generate_sku || form.value.auto_generate_barcode);
  }

  private companyMissing(form: FormGroup): boolean {
    return this.requiresCompany(form) && !form.value.company_id;
  }

  private buildPosFields(form: FormGroup) {
    const companyId = form.value.company_id ? Number(form.value.company_id) : null;
    const productCode = String(form.value.product_code || '').trim();
    const barcode = String(form.value.barcode || '').trim();
    const merchantCategoryId = form.value.merchant_category_id
      ? Number(form.value.merchant_category_id)
      : null;
    return {
      product_code: productCode || undefined,
      barcode: barcode || undefined,
      company_id: companyId || undefined,
      merchant_category_id: merchantCategoryId || undefined,
      show_in_pos: form.value.show_in_pos !== false,
      pos_sort_order: Number(form.value.pos_sort_order) || 0,
      auto_generate_sku: !!form.value.auto_generate_sku,
      auto_generate_barcode: !!form.value.auto_generate_barcode,
      generate_ai_image: !!form.value.generate_ai_image,
      ai_image_prompt: String(form.value.ai_image_prompt || '').trim() || undefined,
    };
  }

  private buildImageSaveFields(form: FormGroup) {
    const fields: any = {};
    if (this.pendingPreviewKey) {
      fields.preview_key = this.pendingPreviewKey;
    } else if (form.value.generate_ai_image) {
      fields.generate_ai_image = true;
      const prompt = String(form.value.ai_image_prompt || this.aiPrompt || '').trim();
      if (prompt) fields.ai_image_prompt = prompt;
    }
    return fields;
  }

  resetAddForm() {
    this.addProduct.reset({
      product_name_en: '',
      product_name_ar: '',
      product_name_he: '',
      des_ar: '',
      des_en: '',
      des_he: '',
      product_code: '',
      barcode: '',
      company_id: null,
      price: 0,
      measurement_unit_id: null,
      categories_id: null,
      merchant_category_id: null,
      show_in_pos: true,
      pos_sort_order: 0,
      auto_generate_sku: false,
      auto_generate_barcode: false,
      generate_ai_image: false,
      ai_image_prompt: '',
      merchant_id: this.merchantId,
      created_by: this.userRegistId,
    });
    this.pendingPreviewKey = null;
    this.aiPrompt = '';
    this.validate = false;
  }

  addedData() {
    const product_name_he = String(this.addProduct.value.product_name_he)?.trim() || '';

    if (product_name_he === '') {
        Swal.fire({
            icon: 'warning',
            title: this.msg(
              'يرجى ملء الحقول المطلوبة وعدم تركها فارغة أو تحتوي على مسافات فقط',
              'Please fill out the required fields and do not leave them empty or containing only spaces',
              'אנא מלא את השדות הנדרשים ואל תשאיר אותם ריקים או המכילים רק רווחים'
            )
        });

        this.addProduct.markAllAsTouched();
        this.validate = !this.validate;
        return;
    }

    if (this.companyMissing(this.addProduct)) {
      Swal.fire({
        icon: 'warning',
        title: this.msg(
          'يجب اختيار المصلحة التجارية عند تعيين أو توليد SKU / Barcode',
          'Company is required when setting or generating SKU / Barcode',
          'יש לבחור חברה בעת הגדרה או יצירה של SKU / Barcode'
        )
      });
      return;
    }

    const productNameHe = this.addProduct.value.product_name_he;
    const descriptionNameHe = this.addProduct.value.des_he;
    this.addProduct.patchValue({
        product_name_ar: productNameHe,
        product_name_en: productNameHe,
        des_ar: descriptionNameHe,
        des_en: descriptionNameHe,
    });

    const pos = this.buildPosFields(this.addProduct);
    const imageFields = this.buildImageSaveFields(this.addProduct);
    let model = {
        product_name_en: this.addProduct.value.product_name_en,
        product_name_ar: this.addProduct.value.product_name_ar,
        product_name_he: this.addProduct.value.product_name_he,
        product_code: pos.product_code || '',
        barcode: pos.barcode,
        company_id: pos.company_id,
        price: this.addProduct.value.price || 0,
        des_ar: this.addProduct.value.des_ar || '',
        des_en: this.addProduct.value.des_en || '',
        des_he: this.addProduct.value.des_he || '',
        measurement_unit_id: this.addProduct.value.measurement_unit_id || null,
        categories_id: this.addProduct.value.categories_id || null,
        merchant_category_id: pos.merchant_category_id,
        show_in_pos: pos.show_in_pos,
        pos_sort_order: pos.pos_sort_order,
        auto_generate_sku: pos.auto_generate_sku,
        auto_generate_barcode: pos.auto_generate_barcode,
        ...imageFields,
        merchant_id: Number(this.merchantId),
        created_by: Number(this.userRegistId),
    };

    this.spinner.show();
    this.service.Post(AddProductEndPoint.POST, model).subscribe((res) => {
        if (res.status === 200) {
            Swal.fire({
                icon: 'success',
                title: this.apiMsg(res)
            });
            this.modalService.dismissAll();
            this.getAllActiveCategories();
            this.getActiveMerchantCategories();
            this.getAllCustomerType();
            this.getAllActiveMeasurementUnits();
            this.getAllProductsBasedOnMerchant();
            this.resetAddForm();
        } else if (res.status === 400 || res.status === 403 || res.status === 500) {
            Swal.fire({
                icon: 'error',
                title: this.apiMsg(res)
            });
        }
        this.spinner.hide();
    });
};

  changeStatus(id:number, product_status:any){
    this.spinner.show();
  
    let model =
    {
      "product_status": product_status == 1 ? 59 : 1,
     "updated_by": this.userRegistId
    }
  
    this.service.changeProductStatus(id , model ).subscribe(({
      
      next:res =>{
       if (res.status ==200){

        Swal.fire({
          icon: 'success',
          title: this.apiMsg(res),
        })
          this.getAllProductsBasedOnMerchant();
          this.spinner.hide();
       }
  
      },
      error:err =>{
        Swal.fire({
          icon:"error",
          title:err.error.message[0]
        });
        this.spinner.hide();
  
      }
      
    }))
  };

  getId(id: number) {
    this.productId = id;
  };

  filter(event:any)
  {
      this.selectedProduct = event;
  };

   filterMeasurementUnit(event:any)
  {
      this.selectedMeasurementUnit = event;
  };

  setValue(productId: number) {
    for (let i = 0; i < this.productsData.length; i++) {
      if (this.productsData[i].product_id == this.productId) {
        this.updateProduct.controls.product_name_en.setValue(this.productsData[i].product_name_en);
        this.updateProduct.controls.product_name_ar.setValue(this.productsData[i].product_name_ar);
        this.updateProduct.controls.product_name_he.setValue(this.productsData[i].product_name_he);
        this.updateProduct.controls.product_code.setValue(this.productsData[i].product_code);
        this.updateProduct.controls.barcode.setValue(this.productsData[i].barcode || '');
        this.updateProduct.controls.company_id.setValue(this.productsData[i].company_id || null);
        this.updateProduct.controls.price.setValue(this.productsData[i].price);
        this.updateProduct.controls.des_ar.setValue(this.productsData[i].des_ar);
        this.updateProduct.controls.des_en.setValue(this.productsData[i].des_en);
        this.updateProduct.controls.des_he.setValue(this.productsData[i].des_he);
        this.updateProduct.controls.measurement_unit_id.setValue(this.productsData[i].measurement_unit_id);
        this.updateProduct.controls.categories_id.setValue(this.productsData[i].categories_id || null);
        this.updateProduct.controls.merchant_category_id.setValue(this.productsData[i].merchant_category_id || null);
        this.updateProduct.controls.show_in_pos.setValue(
          this.productsData[i].show_in_pos !== false && this.productsData[i].show_in_pos !== 0
        );
        this.updateProduct.controls.pos_sort_order.setValue(this.productsData[i].pos_sort_order ?? 0);
        this.updateProduct.controls.auto_generate_sku.setValue(false);
        this.updateProduct.controls.auto_generate_barcode.setValue(false);
        this.updateProduct.controls.generate_ai_image.setValue(false);
        this.updateProduct.controls.ai_image_prompt.setValue('');
        this.currentImageUrl = this.productsData[i].image_url || null;
        this.pendingPreviewKey = null;
        this.aiPrompt = '';
      }
    };
  };

  executeFunctions(ProductID: number, uploadData: any) {
    this.updatedData = uploadData;
    this.getId(ProductID);
    this.setValue(ProductID);
    this.aiPreviewUrl = null;
    this.aiPreviewKey = null;
    this.aiPrompt = '';
    this.updateMd(this.updatedData);
  };

  executeFunctionsView(ProductID: number, view: any) {
    this.viewData = view;
    this.getId(ProductID);
    this.setValue(ProductID);
    this.updateViewMd(this.viewData);
  };
  
  updateViewMd(paymentsUpdated: any) {
    this.modalService.open(paymentsUpdated, { size: 'xl' , centered:true});
  };

  updateMd(paymentsUpdated: any) {
    this.modalService.open(paymentsUpdated, { size: 'xl' , centered:true});
  };

  updateProductsById() {
    const product_name_he = String(this.updateProduct.value.product_name_he)?.trim() || '';
    const price = Number(this.updateProduct.value.price) || 0;
    const des_he = String(this.updateProduct.value.des_he)?.trim() || '';
    const measurement_unit_id = Number(this.updateProduct.value.measurement_unit_id) || 0;

    if (
        product_name_he === '' ||
        price === 0 ||
        des_he === '' ||
        measurement_unit_id === 0
    ) {
        Swal.fire({
            icon: 'warning',
            title: this.msg(
              'يرجى ملء الحقول المطلوبة وعدم تركها فارغة أو تحتوي على مسافات فقط',
              'Please fill out the required fields and do not leave them empty or containing only spaces',
              'אנא מלא את השדות הנדרשים ואל תשאיר אותם ריקים או המכילים רק רווחים'
            )
        });

        this.updateProduct.markAllAsTouched();
        this.validateUpdate = !this.validateUpdate;
        return;
    }

    if (this.companyMissing(this.updateProduct)) {
      Swal.fire({
        icon: 'warning',
        title: this.msg(
          'يجب اختيار المصلحة التجارية عند تعيين أو توليد SKU / Barcode',
          'Company is required when setting or generating SKU / Barcode',
          'יש לבחור חברה בעת הגדרה או יצירה של SKU / Barcode'
        )
      });
      return;
    }

    const productNameHe = this.updateProduct.value.product_name_he;
    const descriptionNameHe = this.updateProduct.value.des_he;
    this.updateProduct.patchValue({
        product_name_ar: productNameHe,
        product_name_en: productNameHe,
        des_ar: descriptionNameHe,
        des_en: descriptionNameHe,
    });

    const pos = this.buildPosFields(this.updateProduct);
    const imageFields = this.buildImageSaveFields(this.updateProduct);
    let model = {
        product_name_en: this.updateProduct.value.product_name_en,
        product_name_ar: this.updateProduct.value.product_name_ar,
        product_name_he: this.updateProduct.value.product_name_he,
        product_code: pos.product_code || '',
        barcode: pos.barcode,
        company_id: pos.company_id,
        price: price,
        des_ar: this.updateProduct.value.des_ar,
        des_en: this.updateProduct.value.des_en,
        des_he: this.updateProduct.value.des_he,
        measurement_unit_id: measurement_unit_id,
        categories_id: this.updateProduct.value.categories_id || null,
        merchant_category_id: pos.merchant_category_id,
        show_in_pos: pos.show_in_pos,
        pos_sort_order: pos.pos_sort_order,
        auto_generate_sku: pos.auto_generate_sku,
        auto_generate_barcode: pos.auto_generate_barcode,
        ...imageFields,
        merchant_id: Number(this.merchantId),
        updated_by: Number(this.userRegistId),
    };

    this.spinner.show();
    this.service.updateProductsById(this.productId, model).subscribe((res) => {
        if (res.status === 200) {
            Swal.fire({
                icon: 'success',
                title: this.apiMsg(res)
            });
            this.pendingPreviewKey = null;
            this.modalService.dismissAll();
            this.getAllCustomerType();
            this.getAllActiveCategories();
            this.getActiveMerchantCategories();
            this.getAllProductsBasedOnMerchant();
            this.getAllActiveMeasurementUnits();
        } else if (res.status === 400 || res.status === 403 || res.status === 500) {
            Swal.fire({
                icon: 'error',
                title: this.apiMsg(res)
            });
        }
        this.spinner.hide();
    });
}

  openVerticallyCentered(dataDeleted:any) {
    this.modalService.open(dataDeleted, { centered: true });
  };

  onProductImageSelected(event: any) {
    const file: File = event.target.files?.[0];
    if (!file || !this.productId) return;

    const formData = new FormData();
    formData.append('file', file);

    this.spinner.show();
    this.service.uploadProductImage(this.productId, formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        event.target.value = '';
        if (res.status === 200 || res.image_url || res.data?.image_url) {
          const updated = res.data || res;
          this.currentImageUrl = updated.image_url || res.image_url || this.currentImageUrl;
          Swal.fire({
            icon: 'success',
            title: this.apiMsg(res) || this.msg('تم رفع الصورة', 'Image uploaded', 'התמונה הועלתה'),
          });
          this.getAllProductsBasedOnMerchant();
        } else {
          Swal.fire({
            icon: 'error',
            title: this.apiMsg(res) || this.msg('فشل رفع الصورة', 'Image upload failed', 'העלאת התמונה נכשלה'),
          });
        }
      },
      error: () => {
        this.spinner.hide();
        event.target.value = '';
        Swal.fire({
          icon: 'error',
          title: this.msg('فشل رفع الصورة', 'Image upload failed', 'העלאת התמונה נכשלה'),
        });
      },
    });
  }

  generateAiImage(forCreate = false) {
    if (!forCreate && !this.productId) return;

    const form = forCreate ? this.addProduct : this.updateProduct;
    const productName =
      form.value.product_name_he ||
      form.value.product_name_ar ||
      form.value.product_name_en ||
      '';

    const prompt =
      String(form.value.ai_image_prompt || this.aiPrompt || '').trim() || undefined;

    this.spinner.show();
    this.service.aiGenerateProductImage({
      merchant_id: Number(this.merchantId),
      prompt,
      product_name: productName || undefined,
    }).subscribe({
      next: (res) => {
        this.spinner.hide();
        const data = res.data || res;
        this.aiPreviewUrl = data.preview_url || null;
        this.aiPreviewKey = data.preview_key || null;
        if (!this.aiPreviewUrl || !this.aiPreviewKey) {
          Swal.fire({
            icon: 'error',
            title: this.apiMsg(res) || this.msg('فشل توليد الصورة', 'AI image generation failed', 'יצירת התמונה נכשלה'),
          });
          return;
        }
        this.modalService.open(this.aiPreviewModal, { size: 'lg', centered: true });
      },
      error: () => {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.msg('فشل توليد الصورة', 'AI image generation failed', 'יצירת התמונה נכשלה'),
        });
      },
    });
  }

  approveAiImage(modal?: any) {
    if (!this.aiPreviewKey) return;

    // No product yet (create flow): attach preview_key to the upcoming save
    if (!this.productId) {
      this.pendingPreviewKey = this.aiPreviewKey;
      this.currentImageUrl = this.aiPreviewUrl;
      this.addProduct.patchValue({ generate_ai_image: false });
      this.aiPreviewUrl = null;
      this.aiPreviewKey = null;
      if (modal) modal.close();
      Swal.fire({
        icon: 'success',
        title: this.msg(
          'تم تجهيز الصورة — احفظ المنتج لاعتمادها',
          'Image ready — save the product to apply it',
          'התמונה מוכנה — שמור את המוצר כדי להחיל אותה'
        ),
      });
      return;
    }

    this.spinner.show();
    this.service.approveAiProductImage(this.productId, {
      preview_key: this.aiPreviewKey,
    }).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status === 200 || res.image_url || res.data?.image_url) {
          const updated = res.data || res;
          this.currentImageUrl = updated.image_url || res.image_url || this.currentImageUrl;
          this.pendingPreviewKey = null;
          this.aiPreviewUrl = null;
          this.aiPreviewKey = null;
          if (modal) {
            modal.close();
          }
          Swal.fire({
            icon: 'success',
            title: this.apiMsg(res) || this.msg('تم اعتماد الصورة', 'Image approved', 'התמונה אושרה'),
          });
          this.getAllProductsBasedOnMerchant();
        } else {
          // Fallback: attach preview_key on next update save
          this.pendingPreviewKey = this.aiPreviewKey;
          this.currentImageUrl = this.aiPreviewUrl;
          if (modal) modal.close();
          Swal.fire({
            icon: 'info',
            title: this.msg(
              'احفظ التعديل لاعتماد الصورة',
              'Save the update to apply the image',
              'שמור את העריכה כדי להחיל את התמונה'
            ),
          });
        }
      },
      error: () => {
        this.spinner.hide();
        // Keep preview for save-with-preview_key
        this.pendingPreviewKey = this.aiPreviewKey;
        this.currentImageUrl = this.aiPreviewUrl;
        if (modal) modal.close();
        Swal.fire({
          icon: 'info',
          title: this.msg(
            'احفظ التعديل لاعتماد الصورة',
            'Save the update to apply the image',
            'שמור את העריכה כדי להחיל את התמונה'
          ),
        });
      },
    });
  }

  downloadTemplate() {
    this.spinner.show();
    this.service.downloadProductsTemplate().subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'products-template.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.msg('فشل تنزيل القالب', 'Failed to download template', 'הורדת התבנית נכשלה'),
        });
      },
    });
  }

  onExcelFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    this.spinner.show();
    this.service.uploadProductsExcel(formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        event.target.value = '';
        if (res.status === 200) {
          this.importResult = res.data;
          this.modalService.open(this.importResultModal, { size: 'lg', centered: true });
          this.getAllProductsBasedOnMerchant();
        } else {
          Swal.fire({
            icon: 'error',
            title: this.apiMsg(res),
          });
        }
      },
      error: () => {
        this.spinner.hide();
        event.target.value = '';
        Swal.fire({
          icon: 'error',
          title: this.msg('فشل في معالجة ملف الاكسيل', 'Failed to process Excel file', 'עיבוד קובץ האקסל נכשל'),
        });
      },
    });
  }
  
  deleteProductById() {
    this.spinner.show();
    this.service.deleteProductById(this.productId).subscribe({
      next: (res) => {
        if (res.status == 400) {
          Swal.fire({
            icon: 'error',
            title: this.apiMsg(res)
          });
          this.spinner.hide();
          return;
        } else {
          Swal.fire({
            icon: 'success',
            title: this.apiMsg(res)
          });
          this.getAllCustomerType();
          this.getAllProductsBasedOnMerchant();
          this.modalService.dismissAll();
          this.spinner.hide();
        }
      },
      error: (err) => {
        Swal.fire(err.messageAr);
        this.spinner.hide(); 
      }
    });
  };

  ngOnInit() 
  {
  this.searchSubject.pipe(
    debounceTime(400),
    distinctUntilChanged(),
    takeUntil(this.destroy$)
  ).subscribe(() => {
    this.currentPage = 1;
    this.getAllProductsBasedOnMerchant(this.limit, 0);
  });

  this.getAllProductsBasedOnMerchant();
  this.getAllCustomerType();
  this.getAllActiveCategories();
  this.getAllActiveMeasurementUnits();
  this.getAllActiveCompanies();
  this.getActiveMerchantCategories();
  this.layoutVersion = localStorage.getItem("layout_version");
   if (this.layoutVersion == null || this.layoutVersion == undefined) 
   {
     localStorage.setItem("layout_version", "light-only");
     this.layoutVersion= "light-only"; 
   }
    else 
    {
     this.layoutVersion = localStorage.getItem("layout_version"); 
     if (this.layoutVersion === "dark-only")
     {
       document.body.classList.add("dark-only");
     } 
     else
     {
       document.body.classList.add("light-only");
     }
   };
   this.userRegistId = JSON.parse(localStorage.getItem('user_id'));
   this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
   this.user_type = JSON.parse(localStorage.getItem('user_type'));
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
